import React from 'react';
import { FormattedHTMLMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import { FormSelectChoice, InputSelectComponentProps } from '@sheerid/jslib';

import { RadioGroupComponent } from '../FormInputs/RadioGroup/RadioGroupComponent';

const Major = ({
    options, onChange, isErrored,
}: InputSelectComponentProps & InjectedIntlProps) => (
    <div className="sid-major sid-l-space-top-md">
        <fieldset className="sid-major__fieldset">
            <legend className="sid-major__legend">
                <div className="sid-field__label sid-major__label ">
                    <FormattedHTMLMessage
                        id="major"
                        defaultMessage="Major/Concentration"
                    />
                </div>
            </legend>

            <RadioGroupComponent
                className="sid-major__radio-group"
                options={options}
                fieldId="course-type"
                onChange={(major: FormSelectChoice) => onChange(major)}
            />

            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidMajor"
                            defaultMessage="Invalid major"
                        />
                    </div>
                ) : null
            }
        </fieldset>

    </div>
);

export const MajorComponent = injectIntl(Major);
